import RequestPageTwo from "./RequestPageTwo";

const OrdinationReg = () => {
    return (
        <RequestPageTwo title="Ordination Registrations"
            fetchUrl="/get-ordination-registrations"
            editEndpoint="update-ordination-registrations"
            deleteEndpoint="ordination-registrations"
            statusEndpoint="update-ordination-registrations" />
    );
}

export default OrdinationReg;
